var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : _vm.tag,{tag:"component",class:[
    'icon',
    ("icon-theme--" + _vm.theme),
    ("icon--size-" + _vm.size),
    ("icon-" + _vm.name) ],attrs:{"to":_vm.to},on:{"click":function($event){$event.stopPropagation();return _vm.fn.apply(null, arguments)}}},[_c('inline-svg',{style:(_vm.rotation && _vm.rotation !== 0
        ? { transform: ("rotate(" + _vm.rotation + "deg)") }
        : null),attrs:{"src":require(("@/assets/svg/icons/" + _vm.name + ".svg"))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }